import axios from 'axios';
import { tokenUtils } from '../utils/tokenUtils';

const API_URL = process.env.REACT_APP_API_URL + '/Banner';

function getAuthHeaders() {
  const token = tokenUtils.get();
  if (!token) throw new Error('No se encontró token de autenticación');
  return {
    Authorization: `Bearer ${token}`,
  };
}

const handleAuthError = (error) => {
  if (error.response?.status === 401) {
    tokenUtils.clearAuth();
    window.location.href = '/';
  }
};

// Obtener todos los banners
const getBanners = async () => {
  try {
    const response = await axios.get(API_URL, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener banners:', error);
    throw error;
  }
};

// Obtener banners activos (público, sin autenticación)
const getActiveBanners = async () => {
  try {
    const response = await axios.get(`${API_URL}/active`);
    return response.data;
  } catch (error) {
    console.error('Error al obtener banners activos:', error);
    throw error;
  }
};

// Obtener un banner por ID
const getBannerById = async (id) => {
  try {
    const response = await axios.get(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al obtener banner por ID:', error);
    throw error;
  }
};

// Crear un nuevo banner
const createBanner = async (formData) => {
  try {
    const bannerFormData = new FormData();
    
    if (formData.image && formData.image instanceof File) {
      bannerFormData.append('Image', formData.image);
    }
    
    if (formData.text) {
      bannerFormData.append('Text', formData.text);
    }
    
    if (formData.uploadedBy) {
      bannerFormData.append('UploadedBy', formData.uploadedBy);
    }
    
    if (formData.isActive !== undefined) {
      bannerFormData.append('IsActive', formData.isActive);
    }

    if (formData.orden !== undefined && formData.orden !== null && formData.orden !== '') {
      bannerFormData.append('Orden', String(formData.orden));
    }

    if (formData.postId !== undefined && formData.postId !== null && formData.postId !== '') {
      bannerFormData.append('PostId', String(formData.postId));
    } else if (formData.postId === null || formData.postId === '') {
      bannerFormData.append('PostId', '');
    }

    if (formData.courseId !== undefined && formData.courseId !== null && formData.courseId !== '') {
      bannerFormData.append('CourseId', String(formData.courseId));
    } else {
      bannerFormData.append('CourseId', '');
    }
    
    const response = await axios.post(API_URL, bannerFormData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al crear banner:', error);
    throw error;
  }
};

// Actualizar un banner
const updateBanner = async (id, formData) => {
  try {
    const bannerFormData = new FormData();
    
    if (formData.image && formData.image instanceof File) {
      bannerFormData.append('Image', formData.image);
    }
    
    if (formData.text) {
      bannerFormData.append('Text', formData.text);
    }
    
    if (formData.isActive !== undefined) {
      bannerFormData.append('IsActive', formData.isActive);
    }

    if (formData.orden !== undefined && formData.orden !== null && formData.orden !== '') {
      bannerFormData.append('Orden', String(formData.orden));
    }

    if (formData.postId !== undefined && formData.postId !== null && formData.postId !== '') {
      bannerFormData.append('PostId', String(formData.postId));
    } else {
      bannerFormData.append('PostId', '');
    }

    if (formData.courseId !== undefined && formData.courseId !== null && formData.courseId !== '') {
      bannerFormData.append('CourseId', String(formData.courseId));
    } else {
      bannerFormData.append('CourseId', '');
    }
    
    const response = await axios.put(`${API_URL}/${id}`, bannerFormData, {
      headers: {
        ...getAuthHeaders(),
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al actualizar banner:', error);
    throw error;
  }
};

// Eliminar un banner
const deleteBanner = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}/${id}`, {
      headers: getAuthHeaders(),
    });
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al eliminar banner:', error);
    throw error;
  }
};

/** Inscribe al usuario en el curso vinculado al banner. */
const enrollLinkedCourse = async (bannerId) => {
  try {
    const response = await axios.post(
      `${API_URL}/${bannerId}/enroll-course`,
      {},
      { headers: getAuthHeaders() }
    );
    return response.data;
  } catch (error) {
    handleAuthError(error);
    console.error('Error al inscribirse desde el banner:', error);
    throw error;
  }
};

const bannerService = {
  getBanners,
  getActiveBanners,
  getBannerById,
  createBanner,
  updateBanner,
  deleteBanner,
  enrollLinkedCourse,
};

export default bannerService;

